import { Permission } from '../../core/auth/enums/permission.enum';
import { SidebarMenuItem } from './sidebar-menu-item.interface';

export const SIDEBAR_MENU_ITEMS: SidebarMenuItem[] = [
  {
    id: 'links',
    label: 'Links',
    path: '/links',
    icon: 'fa-light fa-link',
    type: 'item',
    permission: Permission.LINKS_VIEW,
  },
  {
    id: 'groups',
    label: 'Groups',
    path: '/groups',
    icon: 'fa-light fa-diagram-project',
    type: 'item',
    permission: Permission.GROUPS_VIEW,
  },
  {
    id: 'power-pages',
    label: 'PowerPages',
    path: '/power-pages',
    icon: 'fa-light fa-clone',
    type: 'item',
    permission: Permission.POWER_PAGES_VIEW,
  },
  {
    id: 'admin',
    label: 'Admin',
    path: '/admin',
    icon: 'fa-light fa-cog',
    type: 'collapse',
    children: [
      {
        id: 'attributes',
        label: 'Attributes',
        path: '/admin/attributes',
        icon: 'fa-solid fa-tags',
        type: 'item',
        permission: Permission.ATTRIBUTES_VIEW,
      },
      {
        id: 'link-templates',
        label: 'Link Templates',
        path: '/admin/link-templates',
        icon: 'fa-solid fa-file-code',
        type: 'item',
        permission: Permission.LINK_TEMPLATES_VIEW,
      },
      {
        id: 'qr-templates',
        label: 'QR Templates',
        path: '/admin/qr-templates',
        icon: 'fa-solid fa-qrcode',
        type: 'item',
        permission: Permission.QR_TEMPLATES_VIEW,
      },
      {
        id: 'users',
        label: 'Users',
        path: '/admin/users',
        icon: 'fa-solid fa-user',
        type: 'item',
        permission: Permission.USERS_VIEW,
      },
      {
        id: 'domains',
        label: 'Domains',
        path: '/admin/domains',
        icon: 'fa-solid fa-user',
        type: 'item',
        permission: Permission.DOMAIN_VIEW,
      },
      {
        id: 'tags',
        label: 'Tags',
        path: '/admin/tags',
        icon: 'fa-solid fa-tag',
        type: 'item',
        permission: Permission.TAGS_VIEW,
      },
      {
        id: 'trusted-destinations',
        label: 'Trusted Destinations',
        path: '/admin/trusted-destinations',
        icon: 'fa-solid fa-shield',
        type: 'item',
        permission: Permission.TRUSTED_DESTINATIONS_VIEW,
      },
      {
        id: 'pending-links',
        label: 'Pending Links',
        path: '/admin/pending-links',
        icon: 'fa-solid fa-clock',
        type: 'item',
        permission: Permission.PENDING_LINKS_VIEW,
      },
      {
        id: 'ip-exclusions',
        label: 'IP Exclusions',
        path: '/admin/ip-exclusions',
        icon: 'fa-solid fa-ban',
        type: 'item',
        permission: Permission.IP_EXCLUSIONS_VIEW,
      },
      {
        id: 'e-link',
        label: 'E-Link',
        path: '/admin/e-link',
        icon: 'fa-solid fa-external-link',
        type: 'item',
        permission: Permission.E_LINKS_VIEW,
      },
    ],
  },
];

